import {Injectable} from "@angular/core";
import * as moment from "moment-mini-ts";

@Injectable({
  providedIn: 'root'
})
export class TemplateService {
  constructor() {
  }

  public createRange(min, max): any {
    const range = [];
    for (let i = min; i <= max; i++) {
      range.push(i);
    }
    return range;
  }

  public limitTemplate(item, amount): boolean {
    if (item.range) {
      let limit = this.createRange(item.min, item.max)
      return limit.some((amounts) => amounts === amount)
    } else {
      return item.min === amount || item.max === amount
    }
  }

  public isLastDigitId(id, client): boolean {
    if(id !== null) {
      let idArray = id.split(',').map(num => Number(num));
      return idArray.includes(client % 10)
    } else {
      return true
    }
  }

  public isOverdue(returnDate): boolean {
    const diff = Math.round(
      moment(returnDate).utcOffset('+03:00').diff(moment().utcOffset('+03:00'), 'days', true)
    )
    return diff < 0
  }

}
